import Styles from './styles.module.css';
import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { deleteDoc, doc, getFirestore, } from 'firebase/firestore';
import { BsThreeDots } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'src/salon/app/hook';

type SchoolItemProps = {
  school: any;
  checklist: string[];
  setCheckList: React.Dispatch<React.SetStateAction<string[]>>;
  // メニューの「編集する」
  onEdit: () => void;
};

const SchoolItem: React.FC<SchoolItemProps> = ({ school, checklist, setCheckList, onEdit }) => {
  
  const db = getFirestore();

  const company = useAppSelector((state) => state.company.company);

  const [ visible1, setVisible1 ] = useState(false);
  const buttonRef1 = useRef<HTMLDivElement | null>(null);
  const divRef1 = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        divRef1.current && !divRef1.current.contains(event.target as Node) &&
        buttonRef1.current && !buttonRef1.current.contains(event.target as Node)
      ) {
        setVisible1(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };

  }, []);
  
  const handleButtonClick1 = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setVisible1((prev) => !prev);
  };

  const deleteDocument = async () => {
    await deleteDoc(doc(db, 'graduation', school.id));
  };

  return (
    <>
    <div className={Styles.items_table}>
      <div className={Styles.items_table_box_2}>
        <h4>{school.name}</h4>
      </div>
      <div className={Styles.items_table_box_3}>
        <h4>{school.school}</h4>
      </div>
      <div className={Styles.items_table_box_4}>
        <h4>{school.graduation_years}</h4>
      </div>
      <div className={Styles.items_table_box_5}>
        <h4>{school.postion}</h4>
      </div>

      <div className={Styles.items_table_list}  ref={buttonRef1} onClick={handleButtonClick1}>
        <BsThreeDots className={Styles.items_table_list_icon} />

        {visible1 && (
          <div ref={divRef1}>
            <p onClick={() => { setVisible1(false); onEdit(); }}>編集する</p>
            <p onClick={() => deleteDocument()}>削除する</p>
          </div>
        )}

      </div>

    </div>
    </>
  );
}

export default SchoolItem;
